#import "../../list/AccessGroupsFields.graphql"
mutation AccessGroupCreate($input: AccessGroupCreateInput!) {
  accessGroupCreate(input: $input) {
    accessGroup {
      ...AccessGroupsFields
    }
  }
}
